import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUser = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.995 7.996a3.996 3.996 0 1 1-7.991 0 3.996 3.996 0 0 1 7.991 0M12 14.875c-3.376 0-6.255.51-6.255 2.553S8.608 19.999 12 19.999c3.373 0 6.254-.512 6.254-2.553 0-2.043-2.862-2.571-6.254-2.571"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
